import { ComponentType } from 'react';
import styled, { css } from 'styled-components';
import { SingleValueProps } from 'react-select';
import { SelectOption } from '../../types';
import { s8 } from '@ardoq/design-tokens';
import { TruncatedTextPopover } from '@ardoq/popovers';

const SingleValueStyle = styled.div<{
  $hasLeftContent?: boolean;
  $hasRightContent?: boolean;
}>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  width: 100%;
  display: flex;
  flex: 1;
  gap: ${s8};

  .textOverflow {
    flex: 1;
  }

  ${({ $hasLeftContent }) =>
    $hasLeftContent &&
    css`
      padding-left: ${s8};
    `}

  ${({ $hasRightContent }) =>
    $hasRightContent &&
    css`
      padding-right: ${s8};
    `}
`;

export const SingleValue: ComponentType<
  SingleValueProps<SelectOption<unknown>>
> = rest => {
  // @ts-expect-error I can't figure out types for this one ATM
  const genericIconName = rest.selectProps.iconName;
  return (
    <SingleValueStyle
      $hasLeftContent={Boolean(
        genericIconName ||
        rest.data.iconName ||
        rest.data.leftContent ||
        rest.data.leftIcon
      )}
      $hasRightContent={Boolean(rest.data.rightContent)}
      id={`${rest.selectProps.inputId}-value`}
    >
      <TruncatedTextPopover className="textOverflow">
        {rest.data.label}
      </TruncatedTextPopover>
      {rest.data.rightContent}
    </SingleValueStyle>
  );
};
